/*
 * Configuration centralisee des commerciaux Penlab.
 * Pour ajouter un commercial : ajouter une ligne ici (cle = identifiant utilise dans ?rep=... et /r/...),
 * puis generer son URL et son QR code (voir SALES_REP_TRACKING.md). Aucune autre modification de code
 * n'est necessaire.
 */
window.PenlabSalesReps = {
  "mathieu": { "name": "Mathieu" },
  "lucie": { "name": "Lucie" }
};
